import React, { memo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import CardImage from '../Views/CardImage';
import { vocabTitle } from '../../../helpers/content';

/**
 * A thesis card: degree and status above the title, and - once the topic is
 * assigned - the student below it. An open topic has no student to show.
 */
const FlexThesisCard = memo(({ item, compact, hideLink, gridLayout }) => {
  const status = vocabTitle(item.thesis_status) || 'open';
  const statusLabel = {
    open: 'Open',
    in_progress: 'In Progress',
    submitted: 'Submitted',
  }[status];
  const subtitle = [
    (item.thesis_degree || []).map(vocabTitle).join(', '),
    statusLabel,
  ]
    .filter(Boolean)
    .join(' · ');

  const titleBlock = (
    <>
      {subtitle && <h6 className="cards__subtitle">{subtitle}</h6>}
      <h4 className="cards__title">{item.title || item.id}</h4>
    </>
  );

  return (
    <div
      className={`cards__item ${gridLayout ? 'cards__item--grid' : 'cards__item--fullwidth'}`}
    >
      {!compact && (
        <CardImage
          item={item}
          fallback="/thesis_default_image.png"
          gridLayout={gridLayout}
          href={hideLink ? undefined : item['@id']}
          speculative
        />
      )}
      <div className="cards__content">
        {hideLink ? (
          titleBlock
        ) : (
          <UniversalLink href={item['@id']}>{titleBlock}</UniversalLink>
        )}
        {status !== 'open' && item.thesis_author && (
          <p className="cards__info">{item.thesis_author}</p>
        )}
        {item.description && (
          <p className="cards__description">{item.description}</p>
        )}
      </div>
    </div>
  );
});

FlexThesisCard.displayName = 'FlexThesisCard';

FlexThesisCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    title: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
    thesis_status: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ token: PropTypes.string }),
    ]),
    thesis_degree: PropTypes.arrayOf(PropTypes.string),
    thesis_author: PropTypes.string,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexThesisCard;
